// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2I13F","modalFooterButton":"ModalNotes_modalFooterButton__3Fj8T"};